module.exports = __WEBPACK_EXTERNAL_MODULE__foundation_smoothScroll__;